const environment = process.env.NODE_ENV || 'development';

const formatMessage = (message, meta) => {
  if (!meta) return message;
  return `${message} ${JSON.stringify(meta)}`;
};

const shouldLog = (level) => {
  if (environment === 'production') {
    return level !== 'debug';
  }
  return true;
};

export const logger = {
  debug: (message, meta) => {
    if (shouldLog('debug')) {
      console.debug(formatMessage(message, meta));
    }
  },
  info: (message, meta) => {
    if (shouldLog('info')) {
      console.info(formatMessage(message, meta));
    }
  },
  warn: (message, meta) => {
    if (shouldLog('warn')) {
      console.warn(formatMessage(message, meta));
    }
  },
  error: (message, meta) => {
    if (shouldLog('error')) {
      console.error(formatMessage(message, meta));
    }
  },
};
